import * as React from 'react'

/**
 * @description Theme icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Theme } from '@sravni/design-system-icons'
 *
 * <Theme />
 * ```
 */
export const Theme = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="Theme" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.833 4.667V3M7.667 3.833H6M3.667 6v3.333M2 7.667h3.333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.253 3.836a.625.625 0 0 0-.005.654c1.397 2.314 1.345 5.11-.514 6.969a5.348 5.348 0 0 1-5.499 1.281.625.625 0 0 0-.777.83c1.472 3.593 5.01 4.85 8.12 4.253 3.112-.597 5.922-3.075 5.922-7.016a7.292 7.292 0 0 0-6.663-7.263.625.625 0 0 0-.584.292Zm1.65 1.172a6.042 6.042 0 0 1 4.347 5.799c0 3.232-2.27 5.283-4.908 5.789-2.268.435-4.713-.29-6.122-2.365a6.578 6.578 0 0 0 5.398-1.888c2.028-2.029 2.284-4.87 1.284-7.335Z"
      fill="currentColor"
    />
  </svg>
))
